import { render } from "./AlertBox.vue?vue&type=template&id=50dec1ce"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"
script.render = render

export default script